import React, { useEffect, useState } from "react";
import styles from "./skills.module.scss";
import RadialPieChart from "../../radialPieChart";
import { useSelector } from "react-redux";

import cx from "classnames";
import _ from "lodash";
import {
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";
import { Tooltip } from "react-bootstrap";
import LinesEllipsis from "react-lines-ellipsis";
import Text from "src/components/text";

const SkillsReport = () => {
  const loading = useSelector((state: any) =>
    _.get(state.coaching, "reports.learnings.skills.loading", false),
  );
  const skills = useSelector((state: any) =>
    _.get(state.coaching, "reports.learnings.skills.items", []),
  );

  const [data, setData] = useState([]);

  useEffect(() => {
    const items = skills.map((item, index) => {
      return {
        name: item.name,
        individual: item.score,
        team: item.teamAverageScore,
      } as { name: string; individual: number; team: number };
    });

    setData(items);
  }, [skills]);

  if(_.size(skills) === 0 && !loading) {
    return <></>
  }

  return (
    <div className={styles.container}>
      <div className={styles.heading}>skills that you've earned last month</div>
      <div className={styles.wrapper}>
        {loading && <PlaceholderSkill />}
        {!loading && (
          <>
            <div style={{ width: _.size(data) * 100, height: 100 }}>
              <ResponsiveContainer>
                <BarChart data={data} barCategoryGap={20}>
                  <XAxis hide />
                  <YAxis hide />
                  <Tooltip />
                  <Bar
                    dataKey="individual"
                    fill="#ff3c68"
                    barSize={12}
                    radius={[4, 4, 0, 0]}
                  />
                  <Bar
                    dataKey="team"
                    fill="#DBDBDB"
                    barSize={12}
                    radius={[4, 4, 0, 0]}
                  />
                </BarChart>
              </ResponsiveContainer>
              <div
                className={styles.skills}
                style={{ width: _.size(data) * 100 }}
              >
                {data.map((item: any, index) => (
                  <Text
                    className={styles.name}
                    text={item.name || "" }
                    lines={1}
                    width={100}
                    tooltip={{placement: 'bottom'}}
                  />
                ))}
              </div>
            </div>
            <div className={styles.points}>
              <div className={styles.content}>
                <div className={cx(styles.icon)} />
                <span className={styles.type}>your skill point</span>
              </div>
              <div className={styles.content}>
                <div className={cx(styles.icon, styles.teamIcon)} />
                <span className={styles.type}>team's average skill point </span>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SkillsReport;

const PlaceholderSkill: React.FC<object> = () => {
  return (
    <div className={cx(styles.placeholder)}>
      <div className={styles.skills}>
        <div className={styles.wrapperSkills}>
          <div className={cx(styles.barOne, styles.block)}></div>
          <div className={cx(styles.barTwo, styles.block)}></div>
        </div>

        <div className={styles.wrapperSkills}>
          <div className={cx(styles.barOne, styles.block)}></div>
          <div className={cx(styles.barTwo, styles.block)}></div>
        </div>

        <div className={styles.wrapperSkills}>
          <div className={cx(styles.barOne, styles.block)}></div>
          <div className={cx(styles.barTwo, styles.block)}></div>
        </div>

        <div className={styles.wrapperSkills}>
          <div className={cx(styles.barThree, styles.block)}></div>
          <div className={cx(styles.barFour, styles.block)}></div>
        </div>

        <div className={styles.wrapperSkills}>
          <div className={cx(styles.barOne, styles.block)}></div>
          <div className={cx(styles.barTwo, styles.block)}></div>
        </div>

        <div className={styles.wrapperSkills}>
          <div className={cx(styles.barThree, styles.block)}></div>
          <div className={cx(styles.barFour, styles.block)}></div>
        </div>

        <div className={styles.wrapperSkills}>
          <div className={cx(styles.barOne, styles.block)}></div>
          <div className={cx(styles.barTwo, styles.block)}></div>
        </div>

        <div className={styles.wrapperSkills}>
          <div className={cx(styles.barThree, styles.block)}></div>
          <div className={cx(styles.barFour, styles.block)}></div>
        </div>

        <div className={styles.wrapperSkills}>
          <div className={cx(styles.barOne, styles.block)}></div>
          <div className={cx(styles.barTwo, styles.block)}></div>
        </div>

        <div className={styles.wrapperSkills}>
          <div className={cx(styles.barOne, styles.block)}></div>
          <div className={cx(styles.barTwo, styles.block)}></div>
        </div>
      </div>
    </div>
  );
};
